import { PlanActionTypes } from "../models/planActions";
import { REMOVE_SCORE } from "../types";

export default (data: number): PlanActionTypes => ({
    type: REMOVE_SCORE,
    payload: data,
});
